import Api from '../api';

class BaseApi extends Api {
    baseURL = process.env.REACT_APP_TEMPERATURES_API;
}

export default BaseApi;




// WEBPACK FOOTER //
// ./src/psuite-js/apis/temperatures/base.js